import type { CityConfig } from "../city-template/types";

export const durhamNhConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "New Hampshire Vital Records (Birth, Death, Marriage, Divorce)", href: "https://www.sos.nh.gov/records-management/vital-records", description: "Official New Hampshire Secretary of State vital records office in Concord" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Durham",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "durham-nh",
  route: "/cities/durham-nh",
  title: "Emergency Passport Durham, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Durham, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Seacoast New Hampshire and UNH area travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Durham, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Durham, UNH, and Seacoast New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Durham%20New%20Hampshire%20University%20of%20New%20Hampshire%20campus%20view%20with%20historic%20brick%20buildings%20and%20the%20Thompson%20Hall%20clock%20tower%2C%20vibrant%20college%20town%20atmosphere%20with%20green%20lawns%20and%20autumn%20maple%20trees%2C%20warm%20afternoon%20light%20with%20students%20walking%20on%20campus%20paths%2C%20clean%20and%20inviting%20academic%20scene%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20identifiable%20people%2C%20warm%20brick%20and%20golden%20autumn%20tones%2C%20photorealistic%20campus%20setting&width=1800&height=700&seq=durham-nh-hero-001&orientation=landscape",
  heroImageAlt: "Durham New Hampshire University of New Hampshire campus with historic brick buildings and Thompson Hall clock tower",
  geoPosition: "43.1340;-70.9264",
  geoPlacename: "Durham, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 60–75 minutes from Durham via I-95",
  },
  nearbyCitiesZips: [
    { name: "Durham", zips: "03824" },
    { name: "Dover", zips: "03820–03822" },
    { name: "Newmarket", zips: "03857" },
    { name: "Portsmouth", zips: "03801–03804" },
    { name: "Lee", zips: "03861" },
    { name: "Madbury", zips: "03823" },
    { name: "Barrington", zips: "03825" },
    { name: "Somersworth", zips: "03878" },
    { name: "Rochester", zips: "03839, 03867–03868" },
    { name: "Epping", zips: "03042" },
    { name: "Exeter", zips: "03833" },
    { name: "Stratham", zips: "03885" },
    { name: "Greenland", zips: "03840" },
    { name: "Rye", zips: "03870" },
    { name: "Hampton", zips: "03842–03843" },
    { name: "North Hampton", zips: "03862" },
    { name: "Seabrook", zips: "03874" },
    { name: "Newfields", zips: "03856" },
    { name: "Nottingham", zips: "03290" },
    { name: "Raymond", zips: "03077" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Seacoast New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Dover", route: "/cities/dover" },
    { name: "Exeter", route: "/cities/exeter" },
    { name: "Newmarket", route: "/cities/newmarket" },
    { name: "Somersworth", route: "/cities/somersworth" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Hampton", route: "/cities/hampton" },
    { name: "Lee", route: "/lee" },
  ],
  fpcOfficeAddress: "1 New Hampshire Ave, Portsmouth, NH 03801",
  fpcOfficeNote: "Fast Passport Center serves Durham remotely via secure courier. We do not have a walk-in office in Durham — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Seacoast New Hampshire and UNH area travelers.",
  fpcOfficeDistance: "Serving Strafford County and Seacoast New Hampshire",
  serviceAreaIntro: "From the UNH campus area to the downtown village, from the Oyster River to the Lee town line — Fast Passport Center serves the entire Durham community. We regularly help students, faculty, and residents from Dover, Newmarket, Portsmouth, and Lee get their passports fast.",
  nearbyCitiesIntro: "We serve all Durham neighborhoods and nearby Seacoast New Hampshire cities including Dover, Newmarket, Portsmouth, Lee, Madbury, Barrington, Somersworth, Rochester, Exeter, Stratham, Greenland, Rye, Hampton, and Seabrook. If you are in the greater Durham area, we have you covered.",
  howItWorksIntro: "Most Durham travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Portsmouth International Airport (PSM) just 12 minutes away and Manchester-Boston Regional (MHT) 40 minutes away, Seacoast New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Durham, UNH, and Seacoast New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Durham? Here are the most common ones we hear from Seacoast New Hampshire travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Durham international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda L.",
      location: "Durham, NH",
      rating: 5,
      text: "My study abroad trip to Spain was in 4 days and I realized my passport was expired. Fast Passport Center got me a new one in 36 hours. They saved my semester abroad.",
      service: "Emergency Passport",
    },
    {
      name: "Professor Mark T.",
      location: "Durham, NH",
      rating: 5,
      text: "Needed to renew for a conference in Japan. The process was smooth, they reviewed my documents, and I had my passport in 5 days. Excellent service for UNH faculty.",
      service: "Passport Renewal",
    },
    {
      name: "Jessica W.",
      location: "Dover, NH",
      rating: 5,
      text: "Lost my passport the week before my honeymoon in Italy. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service for Seacoast NH.",
      service: "Lost Passport",
    },
    {
      name: "Ryan C.",
      location: "Newmarket, NH",
      rating: 5,
      text: "As a frequent international traveler from the Seacoast area, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "durham-nh-1",
      name: "Durham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3 Main St",
      city: "Durham",
      state: "NH",
      zip: "03824",
      phone: "(603) 868-2221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Durham. Appointments required. Call ahead to confirm passport acceptance times. Convenient for UNH students and staff.",
      icon: "ri-mail-line",
    },
    {
      id: "durham-nh-2",
      name: "Dover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "133 Central Ave",
      city: "Dover",
      state: "NH",
      zip: "03820",
      phone: "(603) 742-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5.2 miles from Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular alternative for Durham residents. Extended hours available. Photo services on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "durham-nh-3",
      name: "Newmarket Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Main St",
      city: "Newmarket",
      state: "NH",
      zip: "03857",
      phone: "(603) 659-2221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "4.8 miles from Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Durham residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "durham-nh-4",
      name: "Portsmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Islington St",
      city: "Portsmouth",
      state: "NH",
      zip: "03801",
      phone: "(603) 431-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12.5 miles from Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Seacoast area. Extended hours available. Photo services on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "durham-nh-5",
      name: "Exeter Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Front St",
      city: "Exeter",
      state: "NH",
      zip: "03833",
      phone: "(603) 772-2221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8.3 miles from Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Durham and Exeter area. Full passport services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "durham-nh-6",
      name: "Somersworth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Main St",
      city: "Somersworth",
      state: "NH",
      zip: "03878",
      phone: "(603) 692-2221",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "10.2 miles from Durham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Durham residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Durham photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Seacoast New Hampshire acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Durham applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Durham families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Durham travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Durham or Dover." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Durham address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Durham before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Durham for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Seacoast New Hampshire and UNH area travelers." },
    { q: "How fast can I renew my passport in Durham?", a: "Fast Passport Center offers fast passport renewal in Durham in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Durham in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Durham?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Durham residents." },
    { q: "Can I expedite a child passport in Durham?", a: "Yes. Fast Passport Center expedites child passports in Durham for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Durham with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Durham?", a: "With Fast Passport Center's emergency courier service, Durham travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Durham?", a: "Popular options include the Durham Post Office (03824), Dover Post Office (03820), Newmarket Post Office (03857), and Portsmouth Post Office (03801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Durham?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Dover or Newmarket?", a: "We serve all of Seacoast New Hampshire including Dover, Newmarket, Portsmouth, Lee, Madbury, Barrington, Somersworth, Rochester, Exeter, Stratham, Greenland, Rye, Hampton, and Seabrook. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Durham?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Dover", address: "133 Central Ave, Dover, NH 03820", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Portsmouth", address: "15 Islington St, Portsmouth, NH 03801", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "FedEx Office — Portsmouth", address: "15 Islington St, Portsmouth, NH 03801", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Dover", address: "133 Central Ave, Dover, NH 03820", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Portsmouth", address: "1450 Woodbury Ave, Portsmouth, NH 03801", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store-finder" },
    { name: "Rite Aid — Exeter", address: "20 Front St, Exeter, NH 03833", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Postal Annex — Portsmouth", address: "15 Islington St, Portsmouth, NH 03801", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Portsmouth", address: "1450 Woodbury Ave, Portsmouth, NH 03801", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Dover", address: "133 Central Ave, Dover, NH 03820", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Portsmouth", address: "15 Islington St, Portsmouth, NH 03801", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Exeter", address: "20 Front St, Exeter, NH 03833", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Rochester", address: "2 Main St, Rochester, NH 03867", hours: "Mon–Fri: 8AM–5PM", note: "Convenient for northern Strafford County residents.", featured: true },
  ],
  airports: [
    { code: "PSM", name: "Portsmouth International Airport", distance: "12 miles from Durham", address: "36 Airport Rd, Portsmouth, NH 03801", note: "Closest airport for Durham travelers. Limited commercial service with flights to Florida and other domestic destinations.", flightUrl: "https://www.flyportsmouth.com/", flightLabel: "PSM Flight Info", featured: true },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "40 miles from Durham", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Durham travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "60 miles from Durham", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-95.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};